/* ELEMENT - the whole of the theme's own runtime.

   It lives in an asset file rather than inline in a custom-liquid section
   on purpose. Asset files are served verbatim, so Liquid can never rewrite
   the source, and a <script src> always executes.

   Nothing here touches prices, badges or labels. Those render in Liquid in
   card-product.liquid and price.liquid, so they are correct in the first
   paint and correct with scripts blocked, which matters when 82% of
   Element's traffic arrives through in-app browsers. */

/* ---------------------------------------------------------------
   1. Homepage header: tell the document whether the page has been
   scrolled, so the transparent overlay header can pick up a
   background. element-custom.css owns what that looks like.
   --------------------------------------------------------------- */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('element-home')) return;

  var queued = false;

  var apply = function () {
    queued = false;
    root.classList.toggle('element-scrolled', (window.scrollY || 0) > 40);
  };

  var schedule = function () {
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(apply);
    }
  };

  apply();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
})();

/* ---------------------------------------------------------------
   2. Welcome offer popup.

   FREQUENCY. This used to be a one-shot: local storage held a bare '1'
   and the popup never appeared for that browser again, ever. That is
   too tight for a store whose traffic is overwhelmingly first-touch
   paid, because a returning visitor who did not subscribe is a warm
   prospect being shown nothing, and ELEMENT10 has no other issuer.

   It is now two clocks rather than one flag:

     dismissed     RESURFACE_DAYS  the popup was shown and closed
     subscribed    SUBSCRIBER_DAYS they have the code, do not ask again

   Both are timestamps. Set either window to 0 to disable that
   suppression entirely, which is also how you review the popup without
   clearing storage by hand.

   The keys are deliberately the SAME names the live Lovable site uses.
   That site wrote a bare '1', and so did the first build of this theme,
   so a legacy value is treated as "dismissed just now" and rewritten as
   a timestamp. Those visitors start a clock instead of being suppressed
   forever, and nobody gets the popup twice on the day of the migration.

   TWO THINGS HERE ARE NOT DECORATION.

   The opening transition is started by forcing a reflow, NOT by
   requestAnimationFrame. rAF callbacks do not run while a tab is in the
   background, so if a visitor opened the page and looked away, the
   is-open class was never added and the popup sat in the DOM fully
   transparent. It looked exactly like the popup failing to appear on
   desktop, which is what was reported.

   And the timer will not open it while the tab is hidden. CSS
   transitions are also frozen in a background tab, so opening there
   burns the showing on a fade nobody watched. It waits for the tab to
   come back instead.
   --------------------------------------------------------------- */
(function () {
  var SEEN = 'element-welcome-seen';
  var UNLOCKED = 'element-welcome-unlocked';
  var DAY = 86400000;

  /* Defaults. The section can override either by rendering
     data-resurface-days / data-subscriber-days on the modal. */
  var RESURFACE_DAYS = 14;
  var SUBSCRIBER_DAYS = 365;

  var read = function (key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  };

  var write = function (key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  };

  var stampedAt = function (key) {
    var raw = read(key);
    if (!raw) return 0;

    /* Legacy one-shot flag from the live site or the first build here.
       Convert it to a timestamp on first sight so it can expire. */
    if (raw === '1') {
      var now = Date.now();
      write(key, String(now));
      return now;
    }

    var when = parseInt(raw, 10);
    return isNaN(when) || when <= 0 ? 0 : when;
  };

  var suppressed = function (key, days) {
    if (!days || days <= 0) return false;
    var when = stampedAt(key);
    if (!when) return false;
    return Date.now() - when < days * DAY;
  };

  var setting = function (modal, name, fallback) {
    var value = parseInt(modal.getAttribute(name), 10);
    return isNaN(value) || value < 0 ? fallback : value;
  };

  var start = function () {
    var modal = document.getElementById('ElementWelcome');
    if (!modal) return;

    var resurfaceDays = setting(modal, 'data-resurface-days', RESURFACE_DAYS);
    var subscriberDays = setting(modal, 'data-subscriber-days', SUBSCRIBER_DAYS);

    var justSignedUp = !!modal.querySelector('[data-element-welcome-success]');
    var lastFocus = null;

    var open = function () {
      if (!modal.hidden && modal.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var target = modal.querySelector('input, button');
      if (target) target.focus();
      write(SEEN, String(Date.now()));
    };

    var openWhenVisible = function () {
      if (!document.hidden) {
        open();
        return;
      }

      var onVisible = function () {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVisible);
        open();
      };

      document.addEventListener('visibilitychange', onVisible);
    };

    var close = function () {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { modal.hidden = true; }, 350);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-element-welcome-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });

    var copy = modal.querySelector('[data-element-welcome-copy]');
    var code = modal.querySelector('[data-element-welcome-code]');

    if (copy && code) {
      copy.addEventListener('click', function () {
        var value = code.textContent.trim();
        var done = function () { copy.textContent = 'Copied'; };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done, function () {});
        }
      });
    }

    /* They just subscribed on this page load. Show them the code, and
       start the long clock. */
    if (justSignedUp) {
      write(UNLOCKED, String(Date.now()));
      openWhenVisible();
      return;
    }

    if (suppressed(UNLOCKED, subscriberDays)) return;
    if (suppressed(SEEN, resurfaceDays)) return;

    var delay = parseInt(modal.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 5;
    window.setTimeout(openWhenVisible, delay * 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------
   3. Draft preview only: keep the preview from throwing you onto the
   live site.

   Element's primary domain, elementeg.shop, points at Lovable rather
   than at Shopify. Shopify forwards every *.myshopify.com request to
   the primary domain unless the request carries _fd=0, so while
   reviewing an unpublished theme the FIRST click on any link lands on
   the Lovable storefront and it looks as though the draft reverted.
   _fd=0 is per request, not a cookie, so it has to be carried on every
   internal link AND on every AJAX call.

   Gated on the hostname ending in myshopify.com, so once this theme is
   published on the real domain the whole block returns immediately.
   Remove it after the domain cutover.
   --------------------------------------------------------------- */
(function () {
  if (!/\.myshopify\.com$/i.test(window.location.hostname)) return;

  var stampUrl = function (value) {
    try {
      var url = new URL(value, window.location.href);
      if (url.hostname !== window.location.hostname) return value;
      if (url.searchParams.get('_fd') === '0') return value;
      url.searchParams.set('_ab', '0');
      url.searchParams.set('_fd', '0');
      url.searchParams.set('_sc', '1');
      return url.toString();
    } catch (error) {
      return value;
    }
  };

  var stamp = function (anchor) {
    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    var next = stampUrl(anchor.href);
    if (next !== anchor.href) anchor.href = next;
  };

  var queued = false;

  var sweep = function () {
    queued = false;
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) stamp(anchors[i]);
  };

  var schedule = function () {
    if (!queued) {
      queued = true;
      window.setTimeout(sweep, 0);
    }
  };

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /* Shopify renders the accelerated checkout buttons itself - Apple Pay,
     Buy it now, and the More payment options link underneath them - inside
     a <shopify-accelerated-checkout> web component. Those links live in a
     shadow root, which document.querySelectorAll cannot see, so the sweep
     above never reaches them. Unstamped, More payment options navigates to
     the primary domain, Lovable has no such route, and the tab lands on a
     Lovable 404 that reads as an empty page.

     A capture-phase click listener sees into the shadow tree through
     composedPath, so the anchor can be stamped at click time, before the
     browser follows it. Same-host links only; everything else is left
     alone. This is preview scaffolding and goes away with the block. */
  document.addEventListener(
    'click',
    function (event) {
      if (typeof event.composedPath !== 'function') return;
      var path = event.composedPath();
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node && node.tagName === 'A' && node.getAttribute && node.getAttribute('href')) {
          stamp(node);
          return;
        }
      }
    },
    true
  );

  /* THE CART. This is the one that actually stops the preview working.

     Dawn posts to /cart/add.js, /cart/update.js and /cart/change.js with
     no query string. On the preview those requests are redirected to the
     primary domain, which is a DIFFERENT ORIGIN, and a cross-origin
     redirect aborts an XHR or fetch outright. So Add to cart silently
     does nothing: no notification, no cart count, no error the shopper
     can see. Stamping anchors does not help, because these are not
     navigations.

     Measured on the draft, 15 Sep: GET /cart.js fails with a network
     error, GET /cart.js?_fd=0 returns 200.

     Both fetch and XMLHttpRequest are wrapped, because apps on this store
     use both. Same-host requests only; anything pointing elsewhere is
     passed through untouched. */
  var nativeFetch = window.fetch;

  if (typeof nativeFetch === 'function') {
    window.fetch = function (resource, init) {
      try {
        if (typeof resource === 'string') {
          resource = stampUrl(resource);
        } else if (resource && typeof resource.url === 'string') {
          var stamped = stampUrl(resource.url);
          if (stamped !== resource.url) resource = new Request(stamped, resource);
        }
      } catch (error) {
        /* never let the wrapper be the reason a request fails */
      }
      return nativeFetch.call(this, resource, init);
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    var args = Array.prototype.slice.call(arguments);
    try {
      if (typeof url === 'string') args[1] = stampUrl(url);
    } catch (error) {
      /* fall through with the original arguments */
    }
    return nativeOpen.apply(this, args);
  };
})();